import { datadogLogs, LogsInitConfiguration } from "@datadog/browser-logs";
import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

import getEnv from "../getEnv";
import isProd from "../isProd";
import isTest from "../isTest";
import ignoreMessage from "./ignoreMessage";

// Datadog RUM application: "Dexibit Navigation"
const APPLICATION_ID = "09109c33-0485-4e44-a62b-24c75323d5a5";
const CLIENT_TOKEN = "pub0562d83443c6623aa94aa875e5ea936d";
const SERVICE = "navigation-client";

const initDatadog = () => {
  if (isTest()) return;

  // Let's record them on prod only
  const enableSessionReplay = isProd();

  const rumInitConfiguration: RumInitConfiguration = {
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.com",
    env: getEnv(),
    service: SERVICE,
    version: import.meta.env.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: enableSessionReplay ? 100 : 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    usePartitionedCrossSiteSessionCookie: true,
    compressIntakeRequests: true,
    defaultPrivacyLevel: "allow",
  };

  datadogRum.init(rumInitConfiguration);

  const logsInitConfiguration: LogsInitConfiguration = {
    clientToken: CLIENT_TOKEN,
    site: "datadoghq.com",
    env: getEnv(),
    service: SERVICE,
    version: import.meta.env.APP_VERSION,
    sessionSampleRate: 100,
    usePartitionedCrossSiteSessionCookie: true,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
    forwardReports: ["intervention", "deprecation"],
    beforeSend: (log) => {
      // discard ad blockers causing those errors
      if (log.http?.status_code === 404 || log.http?.status_code === 0) {
        return false;
      }

      if (ignoreMessage(log.message)) {
        return false;
      }

      return true;
    },
  };

  datadogLogs.init(logsInitConfiguration);
};

export default initDatadog;
